import i18n from '@dms/i18n';

export const APPLICATION_METHOD_OPTIONS = [
  {
    value: 'DISCOUNT_APPLICATION_ON_TOTAL_SELLING_PRICE',
    label: i18n.t('entity.accounting.labels.discountOnTotalSellingPrice'),
  },
  {
    value: 'DISCOUNT_APPLICATION_ON_UNIT_SELLING_PRICE',
    label: i18n.t('entity.accounting.labels.discountOnUnitSellingPrice'),
  },
];
